import { createFileRoute } from '@tanstack/react-router'
import AccessControlTab from '@/pages/admin/AccessControlTab'

export const Route = createFileRoute('/_authenticated/admin/access')({
  component: AccessControlTab,
})
